module.exports = __webpack_public_path__ + "img/DefaultUserImg.6acca5da.png";